import { Location } from "history";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { searchRouteParams } from "./service";

const scrollAppTo = (position: number) => {
  const appContainer = document.getElementById("root");
  if (appContainer) {
    appContainer.scrollTop = position;
  }
};

const createFullPath = (location: Location) => {
  return `${location.pathname}${location.search}`;
};

export interface IWithRouteMatchProps<T = any, S = any> extends RouteComponentProps<T, any, S> {}

interface IPosition {
  top: number;
  height: number;
  name: string;
}

interface IRouteProviderState {
  position: IPosition[];
}

const RESTORE_SCROLL_POSITION_PAGES = ["/", "/job-requests", "/app/job-requests"];

export class RouteProviderComponent extends React.Component<IWithRouteMatchProps> {
  state: IRouteProviderState = {
    position: [],
  };

  componentDidUpdate(prevProps: IWithRouteMatchProps) {
    if (
      this.props.history.action === "POP" ||
      (this.props.history.action === "PUSH" && this.props.location.state?.fromBackButton)
    ) {
      const oldPosition = this.state.position.find(p => p.name === createFullPath(this.props.location));

      if (oldPosition) {
        this.setState({
          position: [...this.state.position.filter(p => p.name !== oldPosition.name)],
        });
        const interval = setInterval(() => {
          const appContainer = document.getElementById("root");
          if (appContainer && appContainer.scrollHeight === oldPosition.height) {
            scrollAppTo(oldPosition.top);
            clearInterval(interval);
          }
        }, 200);
      }
    } else if (this.props.location.pathname !== prevProps.location.pathname) {
      scrollAppTo(0);
    } else {
      const newPage = searchRouteParams(this.props).get("page");
      const oldPage = searchRouteParams(prevProps).get("page");

      // Scroll app to the top if page number is changed
      if (newPage !== oldPage) {
        scrollAppTo(0);
      }
    }
  }

  getSnapshotBeforeUpdate(prevProps: IWithRouteMatchProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      prevProps.history.action === "PUSH" &&
      RESTORE_SCROLL_POSITION_PAGES.find(page => page === prevProps.location.pathname)
    ) {
      const appContainer = document.getElementById("root");
      if (appContainer) {
        const fullName = createFullPath(prevProps.location);
        this.setState({
          position: [
            ...this.state.position.filter(p => p.name !== fullName),
            { top: appContainer.scrollTop, height: appContainer.scrollHeight, name: fullName },
          ],
        });
      }
    }
    return null;
  }

  render() {
    return <>{this.props.children}</>;
  }
}

export const RouteProvider = withRouter(RouteProviderComponent);
